import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const TagFillIcon = _ref => {
  let {
      size,
      color
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M2.5 2.5C2.5 1.80964 3.05964 1.25 3.75 1.25H9.48223C9.81375 1.25 10.1317 1.3817 10.3661 1.61612L19.1161 10.3661C19.6043 10.8543 19.6043 11.6457 19.1161 12.1339L13.3839 17.8661C12.8957 18.3543 12.1043 18.3543 11.6161 17.8661L2.86612 9.11612C2.6317 8.8817 2.5 8.56375 2.5 8.23223V2.5ZM6.875 7.5C7.91053 7.5 8.75 6.66053 8.75 5.625C8.75 4.58947 7.91053 3.75 6.875 3.75C5.83947 3.75 5 4.58947 5 5.625C5 6.66053 5.83947 7.5 6.875 7.5Z",
    fill: color
  }), __jsx("path", {
    d: "M1.61612 9.74112C1.3817 9.50669 1.25 9.18875 1.25 8.85723V2.5C0.559644 2.5 0 3.05964 0 3.75V9.48223C0 9.81375 0.131695 10.1317 0.366116 10.3661L9.11612 19.1161C9.60427 19.6043 10.3957 19.6043 10.8839 19.1161L10.9375 19.0625L1.61612 9.74112Z",
    fill: color
  }));
};
export default TagFillIcon;